export default "__VITE_ASSET__c783c594__"